module.exports = __webpack_public_path__ + "img/email.01d4c00.png";